import { useState } from "react";
import { Col, Row } from "antd";
import PhoneInput from "react-phone-number-input";
import es from "react-phone-number-input/locale/es";
import Input from "components/common/Input";
import TextArea from "antd/lib/input/TextArea";
import CustomSelector from "components/common/Selector";
import DatePickerSelect from "components/common/DatePickerSelect";
import { useTranslation } from "react-i18next";
import s from "../../../../styles/GeneralBody.styles";

function GeneralBody({
  getFieldProps,
  values,
  setFieldValue,
  setFieldTouched,
  touched,
  errors,
}) {
  const { t } = useTranslation();
  const [customerType, setCustomerType] = useState(values.tags[0]);
  const onChange = (e) => {
    setCustomerType(e);
    setFieldValue("tags", [e]);
  };
  return (
    <s.TopSectionsContainer>
      <s.SectionTitle style={{ marginBottom: "18px" }}>
        {customerType === "person"
          ? t("components.CustomerList.AddCustomer.GeneralBody.personalInfo")
          : t("components.CustomerList.AddCustomer.GeneralBody.companyInfo")}
      </s.SectionTitle>

      <s.Line style={{ marginBottom: "10px" }} />

      <Row
        gutter={9}
        style={{
          marginBottom: "28px",
        }}
      >
        <Col span={8}>
          <s.SubTitle>{t("Customers.fields.type.label")}</s.SubTitle>
          <CustomSelector
            border="#959faf"
            options={[
              {
                name: t("Customers.fields.type.staff"),
                value: "person",
              },
              {
                name: t("Customers.fields.type.business"),
                value: "business",
              },
            ]}
            style={{ width: "100%" }}
            placeholder={t("Customers.fields.type.placeholder")}
            value={customerType}
            onChange={onChange}
          />
        </Col>
        <Col span={8}>
          {customerType === "person" ? (
            <>
              <s.SubTitle>{t("Customers.fields.name.label")}*</s.SubTitle>
              <Input
                placeholder={t("Customers.fields.name.placeholder")}
                valid={touched.name && errors.name}
                {...getFieldProps("name")}
              />
              {touched.name && errors.name && (
                <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
              )}
            </>
          ) : (
            <>
              <s.SubTitle>
                {t("Customers.fields.name.labelCompany")}*
              </s.SubTitle>
              <Input
                placeholder={t("Customers.fields.name.placeholder")}
                valid={touched.name && errors.name}
                {...getFieldProps("name")}
              />
              {touched.name && errors.name && (
                <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
              )}
            </>
          )}
        </Col>
        <Col span={8}>
          {customerType === "person" ? (
            <>
              <s.SubTitle>{t("Customers.fields.lastName.label")}*</s.SubTitle>
              <Input
                placeholder={t("Customers.fields.lastName.placeholder")}
                valid={touched.lastName && errors.lastName}
                {...getFieldProps("lastName")}
              />
              {touched.lastName && errors.lastName && (
                <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
              )}
            </>
          ) : (
            <>
              <s.SubTitle>{t("Customers.fields.idNumber.label")}*</s.SubTitle>
              <Input
                placeholder={t("Customers.fields.idNumber.placeholder")}
                valid={touched.idNumber && errors.idNumber}
                {...getFieldProps("idNumber")}
              />
              {touched.idNumber && errors.idNumber && (
                <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
              )}
            </>
          )}
        </Col>
      </Row>
      {/* ------- */}
      <Row
        gutter={9}
        style={{
          marginBottom: "28px",
        }}
      >
        <Col flex={2}>
          {customerType === "person" ? (
            <>
              <s.SubTitle>{t("Customers.fields.idNumber.label")}</s.SubTitle>
              <Input
                placeholder={t("Customers.fields.idNumber.placeholder")}
                {...getFieldProps("idNumber")}
              />
            </>
          ) : (
            <>
              <s.SubTitle>{t("Customers.fields.contactName.label")}</s.SubTitle>
              <Input
                placeholder={t("Customers.fields.contactName.placeholder")}
                {...getFieldProps("contactName")}
              />
            </>
          )}
        </Col>
        <Col flex={2}>
          <s.SubTitle>{t("Customers.fields.phone.label")}</s.SubTitle>
          <PhoneInput
            labels={es}
            limitMaxLength={13}
            international={false}
            placeholder={t("Customers.fields.phone.placeholder")}
            defaultCountry="ES"
            value={values.contactPhone}
            onChange={(value) => [
              setFieldValue("contactPhone", value),
              setFieldTouched("contactPhone", value),
            ]}
          />
        </Col>
        <Col flex={2}>
          <s.SubTitle>{t("Customers.fields.email.label")}</s.SubTitle>
          <Input
            placeholder={t("Customers.fields.email.placeholder")}
            valid={touched.email && errors.email}
            {...getFieldProps("email")}
          />
          {touched.email && errors.email && (
            <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
          )}
        </Col>
      </Row>
      {/* ------- */}
      <Row gutter={9}>
        {customerType === "person" ? (
          <>
            <Col flex={2}>
              <s.SubTitle>{t("Customers.fields.dateOfBirth.label")}</s.SubTitle>
              <DatePickerSelect
                onChange={(val) => setFieldValue("dateOfBirth", val)}
                value={values?.dateOfBirth}
                placeholder={t("Customers.fields.dateOfBirth.placeholder")}
              />
            </Col>
            <Col flex={2}>
              <s.SubTitle>{t("Customers.fields.ref.label")}</s.SubTitle>
              <Input
                placeholder={t("Customers.fields.ref.placeholder")}
                {...getFieldProps("ref")}
              />
            </Col>
          </>
        ) : (
          <Col span={8}>
            <s.SubTitle>{t("Customers.fields.ref.label")}</s.SubTitle>
            <Input
              placeholder={t("Customers.fields.ref.placeholder")}
              {...getFieldProps("ref")}
            />
          </Col>
        )}
      </Row>
      {/* ------- */}
      <s.SectionTitle style={{ marginBottom: "18px", marginTop: "67px" }}>
        {t("components.CustomerList.AddCustomer.GeneralBody.address")}
      </s.SectionTitle>
      <s.Line style={{ marginBottom: "10px" }} />
      {/* ------- */}
      <Row
        gutter={9}
        style={{
          marginBottom: "28px",
        }}
      >
        <Col flex={2}>
          <s.SubTitle>
            {t("Customers.fields.address1.label")}{" "}
            {customerType === "person" ? "" : "*"}
          </s.SubTitle>
          <Input
            placeholder={t("Customers.fields.address1.placeholder")}
            valid={touched.address1 && errors.address1}
            {...getFieldProps("address1")}
          />
          {touched.address1 && errors.address1 && (
            <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
          )}
        </Col>
        <Col flex={2}>
          <s.SubTitle>{t("Customers.fields.address2.label")}</s.SubTitle>
          <Input
            placeholder={t("Customers.fields.address2.placeholder")}
            {...getFieldProps("address2")}
          />
        </Col>
        <Col flex={2}>
          <s.SubTitle>
            {t("Customers.fields.city.label")}{" "}
            {customerType === "person" ? "" : "*"}
          </s.SubTitle>
          <Input
            placeholder={t("Customers.fields.city.placeholder")}
            valid={touched.city && errors.city}
            {...getFieldProps("city")}
          />
          {touched.city && errors.city && (
            <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
          )}
        </Col>
      </Row>
      {/* ------- */}
      <Row
        gutter={9}
        style={{
          marginBottom: "28px",
        }}
      >
        <Col flex={2}>
          <s.SubTitle>
            {t("Customers.fields.zip.label")}{" "}
            {customerType === "person" ? "" : "*"}
          </s.SubTitle>
          <Input
            placeholder={t("Customers.fields.zip.placeholder")}
            valid={touched.zip && errors.zip}
            {...getFieldProps("zip")}
          />
          {touched.zip && errors.zip && (
            <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
          )}
        </Col>
        <Col flex={2}>
          <s.SubTitle>
            {t("Customers.fields.country.label")}{" "}
            {customerType === "person" ? "" : "*"}
          </s.SubTitle>
          <Input
            placeholder={t("Customers.fields.country.placeholder")}
            valid={touched.country && errors.country}
            {...getFieldProps("country")}
          />
          {touched.country && errors.country && (
            <s.messageAlert>{t("formValidations.required")}</s.messageAlert>
          )}
        </Col>
      </Row>
      {/* ------- */}
      <s.SectionTitle style={{ marginBottom: "18px", marginTop: "67px" }}>
        {t("components.CustomerList.AddCustomer.GeneralBody.additionalNotes")}
      </s.SectionTitle>
      <s.Line style={{ marginBottom: "10px" }} />
      {/* ------- */}
      <Row
        gutter={9}
        style={{
          marginTop: "25px",
        }}
      >
        <Col flex={2}>
          <TextArea
            rows={4}
            placeholder={t("Customers.fields.notes.placeholder")}
            {...getFieldProps("notes")}
          />
        </Col>
      </Row>
    </s.TopSectionsContainer>
  );
}

export default GeneralBody;
